export class Tabs {
  constructor() {
    const sidebars = document.querySelectorAll("._industry_AI__sidebar");
    const contents = document.querySelectorAll("._industry_AI__content");
    const sliders = document.querySelectorAll("._industry-slider");

    sidebars.forEach((s, sid) => {
      const wrappers = s.querySelectorAll(".tm-group");
      const buttons = s.querySelectorAll(".tm-button-wrapper");

      buttons.forEach((b, bid) => {
        b.addEventListener("click", (e) => {
          e.preventDefault();

          wrappers.forEach((w, wid) => {
            if (wid === bid) {
              w.querySelector(".tm-button-wrapper").classList.add("active");
              w.querySelector(".tm-heading").classList.add("active");
            } else {
              w.querySelector(".tm-button-wrapper").classList.remove("active");
              w.querySelector(".tm-heading").classList.remove("active");
            }
          });

          if (window.innerWidth > 981) {
            const images = contents[sid].querySelectorAll(".tm-image");
            images.forEach((img, tid) => {
              if (tid === bid) {
                img.classList.add("active");
              } else {
                img.classList.remove("active");
              }
            });

            const sliderGroups = sliders[sid].querySelectorAll(".tm-swiper");
            sliderGroups.forEach((slider, gid) => {
              if (gid === bid) {
                slider.classList.add("active");
                window.dispatchEvent(new Event("resize"));
              } else {
                slider.classList.remove("active");
              }
            });
          } else {
            const sliderGroups = document.querySelectorAll(".tm-swiper");
            sliderGroups.forEach((slider, gid) => {
              if (gid === bid) {
                slider.classList.add("active");
                window.dispatchEvent(new Event("resize"));
              } else {
                slider.classList.remove("active");
              }
            });
          }
        });
      });
    });
  }
}

export default new Tabs();
